'use strict';

var atob = require('./lib/atob');
var btoa = require('./lib/btoa');

module.exports = {
  atob: atob,
  btoa: btoa
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/abab/index.js
// module id = MV7l
// module chunks = 1